import React from "react";
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Paper,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import JsonRenderComponent from "../../../utils/JsonRenderComponent";

interface DataAccordionProps {
  title: string;
  data: any;
  defaultExpanded?: boolean;
  // Optional controlled-expansion mode. When `expanded` is provided, the accordion
  // is controlled (and `onExpandedChange` is called on user toggle); otherwise it
  // falls back to the uncontrolled `defaultExpanded` behavior.
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
}

const DataAccordion: React.FC<DataAccordionProps> = ({
  title,
  data,
  defaultExpanded = false,
  expanded,
  onExpandedChange,
}) => {
  const accordionProps =
    expanded !== undefined
      ? {
          expanded,
          onChange: (_event: React.ChangeEvent<{}>, isExpanded: boolean) =>
            onExpandedChange?.(isExpanded),
        }
      : { defaultExpanded };

  return (
    <Grid item xs={12} style={{ width: "100%", maxWidth: 1200 }}>
      <Accordion {...accordionProps}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Paper
            style={{
              padding: 16,
              width: "100%",
              maxHeight: 400,
              overflow: "auto",
              backgroundColor: "#f5f5f5",
            }}
          >
            <JsonRenderComponent jsonObject={data} printHtml={false} />
          </Paper>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default DataAccordion;
